export default __webpack_public_path__ + "static/media/confirmation.03dc2a69.svg";